module.exports = {"REV_URL":"https://revfin.in/v3/api","BOT_URL":"https://web-bot.revfinloop.com/"};


// WEBPACK FOOTER //
// external "{/"REV_URL/":/"https:/revfin.in/v3/api/",/"BOT_URL/":/"https:/web-bot.revfinloop.com//"}"